import React, { useEffect } from 'react'
import { Meta } from 'react-head'
import DefaultLayout from '../components/DefaultLayout'
import Header from '../components/Header/Header'
import Footer from '../components/Footer/Footer'
import useBreakpoints from '../hooks/useBreakpoints'

function ErrorPage() {
  const { MD, LG } = useBreakpoints()

  useEffect(() => {
    // Show 404's in GA
    const timeout = setInterval(() => {
      if (typeof ga !== 'undefined') {
        ga('send', {
          hitType: 'event',
          eventCategory: 'Error',
          eventAction: 'Page not found',
          eventLabel: document.location.pathname,
        })
        clearInterval(timeout)
      }
    }, 100)
  }, [])

  let imageWidth = 100
  if (MD) imageWidth = 150
  if (LG) imageWidth = '100%'

  return (
    <DefaultLayout>
      <Meta name="robots" content="noindex" />
      <Header inverted={false} />
      <div
        className={`
        relative z-10
        max-w-1024 xxl:max-w-1280
        mt-128 md:mt-192 lg:mt-256
        mb-96
        text-center lg:text-left
        o-width-limiter
      `}
      >
        <img
          className={
            LG ? 'float-right ml-96 -mt-40 xxl:-mt-40' : 'block mb-40 mx-auto'
          }
          style={{
            maxWidth: imageWidth,
            transform: LG ? 'rotateY(-180deg)' : '',
          }}
          src={require('media/apple-sad.png')}
          alt="Sad apple"
        />
        <h1 className="mb-24 type-large-plus">Oops! Page not found</h1>
        <p className="s-text">
          We seem to have messed something up. Sorry about that. Have a look at
          the address to see if you can spot an error.
        </p>
        <a href="http://www.lifesum.com" className="c-button">
          <span>Go to lifesum.com</span>
        </a>
      </div>
      <Footer roomForContent={'small'} />
    </DefaultLayout>
  )
}

export default ErrorPage
